require("../util/autoPadding");
var Nav = {};
var header = $(".js-header");
var navMenu = $("#js-nav-menu");
var currentEle;
Nav.overlay = function () {
  var cartOverlay = $(".js-cart-overlay");
  var navBarCollapse = $("#navbarNav");

  // Cart Overlay
  if (!$("body").is(".isApple, .AndroidOS")) {
    cartOverlay.hover(function () {
      $("body").addClass("cart-overlay");
    }, function () {
      $("body").removeClass("cart-overlay");
    });
  }
  navBarCollapse.on("show.bs.collapse", function () {
    window.dispatchEvent(new Event("resize"));
    $("html").addClass("no-scroll");
  });
  navBarCollapse.on("hidden.bs.collapse", function () {
    $("html").removeClass("no-scroll");
  });
};
Nav.notification = function () {
  if ($(".js-fine-print").length > 0) {
    var fineprint = $(".js-fine-print").outerHeight(true);
    header.css("padding-top", fineprint + "px");
    $(window).resize(function () {
      fineprint = $(".js-fine-print").outerHeight(true);
      if (!navMenu.hasClass("is-fixed-top")) {
        header.css("padding-top", fineprint + "px");
      }
    });
  }
};
Nav.dropdownPosition = function () {
  var headerHeight = navMenu.outerHeight(true);
  var dropdownMenu = $(".navbar-nav .dropdown-menu");
  var headroom = $("#js-main-nav-msg").outerHeight(true);
  if (navMenu.hasClass("is-fixed-top")) {
    var dropdownMenuPosition = navMenu.outerHeight();
    dropdownMenu.each(function () {
      var thisMenu = $(this);
      thisMenu.css("margin-top", dropdownMenuPosition + "px");
      $(window).resize(function () {
        headerHeight = navMenu.outerHeight(true);
        thisMenu.css("margin-top", dropdownMenuPosition + "px");
      });
    });
  } else {
    dropdownMenu.each(function () {
      var thisMenu = $(this);
      thisMenu.css("margin-top", headerHeight + headroom + "px");
      $(window).resize(function () {
        headerHeight = navMenu.outerHeight(true);
        thisMenu.css("margin-top", headerHeight + headroom + "px");
      });
    });
  }
};
Nav.dropdown = function () {
  if ($(".navbar-nav .dropdown-menu").length > 0) {
    $(window).on("load", function () {
      Nav.dropdownPosition();
    });
    $(window).scroll(function () {
      Nav.dropdownPosition();
      this.setTimeout(function () {
        Nav.dropdownPosition();
      }, 100);
    });
    $(window).resize(function () {
      Nav.dropdownPosition();
      this.setTimeout(function () {
        Nav.dropdownPosition();
      }, 100);
    });
  }

  //Menu Dropdown Mobile
  var menuToggle = $(".js-menu-dropdown");
  $(document).on("click", ".js-menu-dropdown", function () {
    var thisMenu = $(this);

    // CLOSE
    if (thisMenu.hasClass("show")) {
      // CLOSE THE SELECTED FIRST LEVEL MENU
      thisMenu.removeClass("show");
      thisMenu.next(".js-menu-body").removeClass("show");
      thisMenu.closest(".nav-item.dropdown").removeClass("show");
      thisMenu.closest("#navbarNav").removeClass("has-first-level-open-dropdown has-second-level-open-dropdown");

      // HIDE ANY OPEN SECOND LEVEL IF PARENT IS CLOSE
      thisMenu.closest(".nav-item").find(".js-menu-body .js-mega-col-item").removeClass("is-open");
      thisMenu.closest(".nav-item").find(".mega-submenu .js-submenu-dropdown").removeClass("is-open");
      thisMenu.closest(".nav-item").find(".mega-submenu .js-submenu-body").removeClass("is-open");
    }
    // OPEN
    else {
      // CLOSE OTHER FIRST LEVEL MENUS BEFORE OPENING THE SELECTED FIRST LEVEL MENU
      menuToggle.removeClass("show");
      menuToggle.next(".js-menu-body").removeClass("show");
      menuToggle.closest(".nav-item.dropdown").removeClass("show");

      // HIDE ANY OPEN SECOND LEVEL IF PARENT IS CLOSE
      menuToggle.closest(".nav-item").find(".js-menu-body .js-mega-col-item").removeClass("is-open");
      menuToggle.closest(".nav-item").find(".mega-submenu .js-submenu-dropdown").removeClass("is-open");
      menuToggle.closest(".nav-item").find(".mega-submenu .js-submenu-body").removeClass("is-open");

      // OPEN THE SELECTED FIRST LEVEL MENU
      thisMenu.addClass("show");
      thisMenu.next(".js-menu-body").addClass("show");
      thisMenu.closest(".nav-item.dropdown").addClass("show");
      thisMenu.closest("#navbarNav").removeClass("has-second-level-open-dropdown");
      thisMenu.closest("#navbarNav").addClass("has-first-level-open-dropdown");
    }
  });

  //Submenu Dropdown Mobile
  var subMenuToggle = $(".js-submenu-dropdown");
  $(document).on("click", ".js-submenu-dropdown", function () {
    var thisSubMenu = $(this);

    // CLOSE
    if (thisSubMenu.hasClass("is-open")) {
      thisSubMenu.removeClass("is-open");
      thisSubMenu.next(".js-submenu-body").removeClass("is-open");
      thisSubMenu.closest(".js-mega-col-item").removeClass("is-open");
      thisSubMenu.closest("#navbarNav").removeClass("has-second-level-open-dropdown");
    }
    // OPEN
    else {
      // CLOSE OTHER SECOND LEVEL MENUS BEFORE OPENING THE SELECTED SECOND LEVEL MENU
      subMenuToggle.removeClass("is-open");
      subMenuToggle.next(".js-submenu-body").removeClass("is-open");
      subMenuToggle.closest(".js-mega-col-item").removeClass("is-open");
      thisSubMenu.addClass("is-open");
      thisSubMenu.next(".js-submenu-body").addClass("is-open");
      thisSubMenu.closest(".js-mega-col-item").addClass("is-open");
      thisSubMenu.closest("#navbarNav").addClass("has-second-level-open-dropdown");
    }
  });
  $(".navbar-nav .nav-item.dropdown").on("hide.bs.dropdown", function (e) {
    if (e.clickEvent) {
      e.preventDefault();
    }
  });
  $(document).on("click", ".js-first-level-no-link", function () {
    $(this).next(".js-menu-dropdown").click();
  });
  $(document).on("click", ".js-second-level-no-link", function () {
    $(this).next(".js-submenu-dropdown").click();
  });
};
Nav.menuEllipsis = function () {
  $(".mega-menu .title").txtTruncate({
    end: "...",
    lines: 1
  });
};
Nav.scrollingInit = function () {
  var ele = document.getElementsByClassName("js-accordion-toggle");
  if (!ele) return;
  for (var i = 0; i < ele.length; i++) {
    ele[i].addEventListener("click", function () {
      Nav.actions(this);
    });
    ele[i].id = "btnFilterAccordion" + i;
    if (i > 10000) break;
  }
};
Nav.actions = function (e) {
  if (!e) return;
  currentEle = e.id;
  if (!e.classList.contains("is-active")) {
    e.classList.add("is-active");
    setTimeout(function () {
      Nav.scrollEffect(currentEle);
    }, 300);
  } else {
    e.classList.remove("is-active");
  }
};
Nav.scrollEffect = function (e) {
  if (!e) return;
  var navHeight = $("#js-main-nav-msg").height() + jQuery("#js-nav-menu").height() - 2;
  if ($("body").hasClass("is-admin-active") && $("#wpadminbar")) {
    navHeight = navHeight + $("#wpadminbar").height();
  }
  $("html, body").animate({
    scrollTop: $("#" + e).parent().offset().top - navHeight
  }, 500);
};
Nav.flow = function () {
  var ele = document.getElementsByClassName("nav-item");
  if (!ele) return;
  $(".nav-item:not(.nav-item-cart)").on("show.bs.dropdown", function () {
    $(".navbar-collapse").css("overflow-y", "hidden");
    $("body").css("overflow-y", "hidden");
  });
  $(".nav-item:not(.nav-item-cart)").on("hide.bs.dropdown	", function () {
    $(".navbar-collapse").css("overflow-y", "auto");
    $("body").css("overflow-y", "auto");
  });
};
Nav.interstellar = function () {
  var interstellarBanner = $(".js-interstellar-banner");
  if (interstellarBanner.length === 0) return;
  var interstellarLogo = $(".js-interstellar-logo");
  var interstellarBannerPos = interstellarBanner.position().top + interstellarBanner.offset().top + interstellarBanner.outerHeight(true) - 60;
  $(window).scroll(function () {
    var scrollPos = $(window).scrollTop();
    if (interstellarBannerPos <= scrollPos) {
      interstellarLogo.addClass("animate");
    } else {
      interstellarLogo.removeClass("animate");
    }
  });
  var menuWithLinks = document.querySelectorAll('a.has-href');
  if (menuWithLinks.length > 0) {
    menuWithLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        link.classList.add('is-active');
      });
    });
  }
};
Nav.megaColumns = function () {
  var navColumns = $(document).find(".js-mega-column");
  if (navColumns.length > 0) {
    navColumns.each(function () {
      var items = $(this).find(".js-mega-col-item");
      var desktopItems = $(this).find(".js-mega-col-item.mega-col-item-view-desktop");
      var mobileItems = $(this).find(".js-mega-col-item.mega-col-item-view-mobile");
      var hideAllItems = $(this).find(".js-mega-col-item.mega-col-item-hidden");
      if (mobileItems.length === items.length) {
        $(this).addClass("mega-col-hidden-desktop");
      } else if (desktopItems.length === items.length) {
        $(this).addClass("mega-col-hidden-mobile");
      } else if (hideAllItems.length === items.length) {
        $(this).addClass("mega-col-hidden");
      }
    });
  }
};
$(window).on("load", function () {
  $(".navbar").addClass("visible");
  Nav.scrollingInit();
  Nav.flow();
});
Nav.overlay();
Nav.notification();
Nav.dropdown();
Nav.menuEllipsis();
Nav.interstellar();
Nav.megaColumns();
window.Nav = Nav;


// WEBPACK FOOTER //
// ./scripts/components/nav.js